<div class="dimmer active">
  <div [ngClass]="'lds-ring'+' ' + getCssClass()">
    <div></div>
  </div>
</div>
